import React, { Component } from 'react';
import './Projects.css';

import "fullpage.js/vendors/scrolloverflow"; // Optional. When using scrollOverflow:true
import ReactFullpage from "@fullpage/react-fullpage";


class Projects extends Component {
  onLeave(origin, destination, direction) {
    console.log("Leaving section " + origin.index);
  }
  afterLoad(origin, destination, direction) {
    console.log("After load: " + destination.index);
  }
  render() {
    
    return (
      <section id="works">
      
      <ReactFullpage
        scrollOverflow={true}
        onLeave={this.onLeave.bind(this)}
        
        
        afterLoad={this.afterLoad.bind(this)}
        render={({ state, fullpageApi }) => {
          return (
            <div id="fullpage-wrapper"  >
            <div class="section" fp-noscroll   >
                
                <div className="slide" >
                <div className="Title">WORKS</div>
                  <div className="slide1"> 
                      <div className="slide1Left"></div>
                    <div className="slide1Right">TEXT</div>

                  </div>
                </div>
                <div className="slide">
                <div className="Title">WORKS</div>
                <div className="slide1"> 
                <div className="slide2Left"></div>
                    <div className="slide1Right">TEXT</div>
                </div>
                </div>
                <div className="slide">
                <div className="Title">WORKS</div>
                <div className="slide1" > 
                <div className="slide3Left"></div>
                    <div className="slide1Right">TEXT</div>
                </div>
                </div>
              </div>
              
            </div>
          );
        }}
      />
          

        </section>
    );
  }
}

export default Projects;